// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2RYgl","colCheckbox":"styles_colCheckbox__XAlfK"};